import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { useMutation } from '@tanstack/react-query';
import { Button, Snackbar } from '@otcmarketsgroup/otcm-ui-lib';
import { Save } from 'lucide-react';
import { saveCuf } from '../../api/cuf';
import { useContext } from 'react';
import { NotificationsContext } from '../../context/Notifications.context';
import { ProfileContext } from '../../context/Profile.context';
import { testIds } from '../../constants/testIds';

const SaveForm = ({ email }) => {
    const [notificationState, dispatchNotification] = useContext(NotificationsContext);
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const { profile } = profileState;
    const isSuccess = notificationState.isSuccess;
    const isError = notificationState.isError;

    const mutation = useMutation({
        mutationFn: () => saveCuf({
            cufId: profile.openCufId,
            email: email,
            formData: profile
        }),
        onSuccess: (response) => {
            dispatchProfile({
                type: 'SET_PROFILE',
                payload: response.formData
            });

            dispatchNotification({
                type: 'SAVE_APPLICATION_SUCCESS'
            });
        },
        onError: (err) => {
            dispatchNotification({
                type: 'FAILED_SAVE_APPLICATION'
            });
        }
    });

    const handleSaveClick = () => {
        dispatchNotification({
            type: 'REMOVE_NOTIFICATION'
        });

        mutation.mutate();
    };

    const isDisabled = (isSuccess) || mutation.isPending;
    return (
        <>
            <Snackbar
                open={isSuccess}
                message={`Your profile has been saved ${moment().format('MMMM D, YYYY')}`}
                autoHideDuration={3000}
                showClose
                isSuccess
                onClose={() => dispatchNotification({
                    type: 'REMOVE_NOTIFICATION'
                })}
            />
            <Snackbar
                open={isError}
                message={`Your application failed to be saved ${moment().format('MMMM D, YYYY')}`}
                autoHideDuration={null}
                showClose
                isError
                onClose={() => dispatchNotification({
                    type: 'REMOVE_NOTIFICATION'
                })}
            />
            <Button
                fullWidth
                data-testid={testIds.controlPanel.saveBtn}
                disabled={isDisabled}
                isLoading={mutation.isPending}
                endIcon={<Save size={16} />}
                onClick={handleSaveClick}
            >
                Save
            </Button>
        </>
    );
};

SaveForm.propTypes = {
    email: PropTypes.string.isRequired
};

export default SaveForm;